<template>
	<div class="vote-area">
		<!-- Submitting message -->
		<transition name="fade">
			<div v-if="submitting" class="vote-area__submit">
				<h2>Submitting your votes!</h2>
				<p>Please wait...</p>
				<div class="vote-area__submit__spinner"></div>
			</div>
		</transition>
		<!-- Polaroids -->
		<template v-if="idea">
			<SubmissionPolaroid
				ref="polaroid"
				:submission="idea"
				:key="idea.id"
				:wall="wall"
				@vote="onVote"
			/>
		</template>
	</div>
</template>

<script>
import SubmissionPolaroid from '@/components/main/SubmissionPolaroid'

export default {
	name: 'VoteArea',
	props: {
		idea: Object,
		submitting: Boolean,
		wall: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		trigger(liked) {
			if (this.$refs.polaroid) this.$refs.polaroid.trigger(liked)
		},
		onVote(liked) {
			this.$emit('vote', liked)
		}
	},
	components: {
		SubmissionPolaroid
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';

.vote-area {
	&__submit {
		@extend %abs-full;
		@extend %flex-center;
		flex-direction: column;
		color: white;

		h2 {
			margin: 0;
		}

		&__spinner {
			@include spinner($col: $white);
		}
	}
}
</style>
